export const error = {
    err: 'Something went wrong'
}